import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ImportCalculator from "@/components/ImportCalculator";
import AdminPanel from "@/components/AdminPanel";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ImportCalculator />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
